import { useEffect } from 'react'
import { validateUPC, validateChaveFCI } from '../../utils/validators'
import { applyPriceMask, applyFCIMask } from '../../utils/formatters'
import { ORIGEM_OPTIONS } from '../../constants/tax-constants'

export const BasicProductFields = ({ 
  register, 
  errors, 
  watch, 
  setValue,
  disabled = false 
}) => {
  const watchedPrice = watch('price')
  const watchedChaveFCI = watch('chave_fci')

  useEffect(() => {
    if (watchedPrice !== undefined) {
      const maskedPrice = applyPriceMask(watchedPrice)
      if (maskedPrice !== watchedPrice) {
        setValue('price', maskedPrice, { shouldValidate: false })
      }
    }
  }, [watchedPrice, setValue])

  useEffect(() => {
    if (watchedChaveFCI !== undefined) {
      const maskedFCI = applyFCIMask(watchedChaveFCI)
      if (maskedFCI !== watchedChaveFCI) {
        setValue('chave_fci', maskedFCI, { shouldValidate: false })
      }
    }
  }, [watchedChaveFCI, setValue])

  return (
    <div className="space-y-6">

      {/* First line: SKU and Bar Code */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            SKU * <span className="text-xs text-gray-500">(não editável)</span>
          </label>
          <div className="relative">
            <input
              {...register('sku', {
                required: 'SKU é obrigatório'
              })}
              disabled={true}
              className="w-full px-3 py-2 border-2 border-gray-300 rounded-md bg-gray-50 text-gray-700 cursor-not-allowed font-mono"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
          </div>
          <p className="mt-1 text-xs text-gray-500">Identificador único do produto (fixo)</p>
          {errors.sku && (
            <p className="mt-1 text-sm text-red-600">{errors.sku.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Código de Barras (UPC) *
          </label>
          <input
            {...register('bar_code', {
              validate: validateUPC
            })}
            placeholder="Ex: 1234567890123"
            disabled={disabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <p className="mt-1 mb-0 text-xs text-gray-500">Apenas números, sem espaços ou caracteres especiais</p>
          {errors.bar_code && (
            <p className="text-sm text-red-600 mb-0">{errors.bar_code.message}</p>
          )}
        </div>
      </div>

      {/* Second line: Product Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nome do Produto *
        </label>
        <input
          {...register('name', {
            required: 'Nome do produto é obrigatório'
          })}
          placeholder="Ex: Produto Natura XYZ"
          disabled={disabled}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
        )}
      </div>

      {/* Third line: Origin and Chave FCI */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Origem *
          </label>
          <select
            {...register('origin', {
              required: 'Origem é obrigatória'
            })}
            disabled={disabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Selecione uma origem</option>
            {ORIGEM_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errors.origin && (
            <p className="mt-1 text-sm text-red-600">{errors.origin.message}</p>
          )}
        </div>
        <div>
          <div className="flex items-center gap-2 mb-2">
          <label className="block text-sm font-medium text-gray-700">
            Chave FCI
          </label>
            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
              Opcional
            </span>
          </div>
          <input
            {...register('fci_key', {
              validate: validateChaveFCI
            })}
            placeholder="Ex: 12345678-ABCD-1234-ABCD-123456789012"
            disabled={disabled}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono"
          />
          {errors.fci_key && (
            <p className="mt-1 text-sm text-red-600">{errors.fci_key.message}</p>
          )}
        </div>

      </div>
    </div>
  )
} 